// removed by extract-text-webpack-plugin
module.exports = {"banner":"_1GfrdtCBH0f_qLHMdIa1Ux","content":"xAZuAj-OIRK-iVhaIV33n","text":"_21USph0Kk6h29Jey2u15-M","scroll":"_2Q3eMVMF3FtuOD2gpBm1J8","scrollImage":"_3pGt-C6XZYvokZJJ1SircR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/banner/banner.css
// module id = 154
// module chunks = 0